const ShimmerConsultationTypeCard = () => {
  return (
    <div className="w-full h-max flex flex-col p-4 rounded-lg bg-surface-primary shadow-fab gap-y-2">
      <div className="flex items-center gap-x-2">
        <div className="min-w-8 w-8 h-8 bg-surface-secondary rounded-lg" />

        <div className="h-6 w-40 bg-surface-secondary rounded-full" />
      </div>

      <div className=" flex flex-col w-full gap-y-2">
        <div className="h-4 w-full bg-surface-secondary rounded-full" />
        <div className="h-4 w-full bg-surface-secondary rounded-full" />
      </div>

      <div className="h-[1px] w-full bg-surface-secondary" />

      <div className="flex items-center justify-between">
        <div className="h-6 w-1/3 bg-surface-secondary rounded-full" />
        <div className="h-8 w-[138px] bg-surface-secondary rounded-full" />
      </div>
    </div>
  );
};

export default ShimmerConsultationTypeCard;
